import { TvGuideDictionary } from "core/tv-guide.context";
import context from "core/tv-guide.context";
import { PopupContents } from "core/types";

type WatchButtonProps = {
    popupContents: PopupContents,
    dictionary: TvGuideDictionary,
    analytics: any,
    setShowInterstitialPopup: any
}

const WatchButton = (props: WatchButtonProps) => {
    const { popupContents, dictionary, analytics, setShowInterstitialPopup } = props;

    if (!popupContents.link.current || popupContents.link.hide) {
        return null;
    }

    return (
        <button
            type="button"
            className="button programme-btn m-1"
            // rel="noreferrer"
            // href="javascript:void(0)"
            {...analytics}
            onClick={() => {
                if (!context.interstitialPopup || localStorage.getItem("storedSelection")) {
                    window.open(popupContents.link.dstvNow)
                } else {
                    setShowInterstitialPopup(true);
                }
            }}
        >
            <span className="icon-watch"></span>
            <span className="text">{dictionary.watchNow}</span>
        </button>
    );
}

export default WatchButton;